export default "__VITE_ASSET__BGtVBsJn__"